import { forEach, forIn } from 'lodash'
import { ObjectSchema } from 'yup'

export const getQueryParams = <T>(search: string) => {
  const query = new URLSearchParams(search)
  const result = {} as any

  query.forEach((value, key) => {
    if (result[key]) {
      const curr = Array.isArray(result[key]) ? result[key] : [result[key]]
      result[key] = [...curr, value]
    } else {
      result[key] = value
    }
  })

  return result as T
}

export const toQueryString = (params: any) => {
  const urlSearchParams = new URLSearchParams()
  forIn(params, (value, key) => {
    if (params[key] == null) {
      return
    }

    if (Array.isArray(value)) {
      forEach(value, (item) => {
        urlSearchParams.append(key, item)
      })
    } else {
      urlSearchParams.append(key, value)
    }
  })

  return urlSearchParams.toString()
}

export const isEmbed = () => location.pathname.indexOf('/embed') >= 0

export const searchUrl = () => (isEmbed() ? '/embed' : '/search')

export const getPageUrl = (url: string) => (isEmbed() ? `/embed${url}` : url)

export const safeCast = <T>(params: any, schema: ObjectSchema<any>) => {
  let result: T
  try {
    result = schema.validateSync(params) as T
  } catch (err) {
    window.newrelic?.noticeError(err)
  }

  return result
}
